<template>
  <div>  
        <div class="changeName">
                <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
            <!-- <span @click="$router.go(-1)">取消</span> -->
                <span>设置性别</span>
                 <span class="buss" @click="successFul">完成</span>
          </div>
                <mt-radio
                    title="请选择性别"
                    align="right"
                    v-model="value"
                    :options="options"
                    @input="check(value)">
               </mt-radio>
                  <!-- <mt-cell title="选中的项">{{ value }}</mt-cell> -->
  </div> 
</template>

<script>
import { Radio } from 'mint-ui';
export default {
  data () {
    return {
       value:"",
      options : [ 
            {
                label: '男',
                value: '男'
            },
            {
                label: '女',
                value: '女'
            }]
    };
  },

 computed:{
     wsWbsocket(){
         return this.$store.state.wsWbsocket;
         }
  },
  methods: {
     check(){
         console.log(this.value)
           localStorage.setItem("sex",this.value)
      
     },

     successFul(){
            var sexOne='"'+'sex'+'":'+'"'+this.value +'"';
             ws.send('{"action":"UpdateUserInfoByUid",'+sexOne+'}');
                  ws.onmessage = (res)=>
                  {
                    var obj = JSON.parse(res.data);

                    if(obj.action=="UpdateUserInfoByUid"){
                          console.log(1111,obj)
                          if(obj.s==0){
                               this.$store.state.userinfo.sex=this.value     
                               if(this.value=="男"){
                                 this.value =0
                                  this.$router.push({
                                        name:"personage",
                                        query:{
                                            sex:this.value
                                        }
                                    })
                               }else if(this.value=="女"){
                                 this.value =1
                                   this.$store.state.userinfo.sex=this.value     
                                  this.$router.push({
                                        name:"personage",
                                        query:{
                                            sex:this.value
                                        }
                                    })
                               }
                                     
                          }else if(obj.s==1029){
                              
                          }
                    }
                  }
             
     }
    
  },
  created(){
      this.check()
  }
}

</script>
<style  scoped>

.changeName .buss {
  display: inline-block;
  font-size: 0.55rem !important;

}
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
.changeName {
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.55rem;
  height: 1.6rem;
  position: relative;
  background: white;
  border-bottom: 0.2rem solid rgba(0, 0, 0, 0.1);
}
.page-radio .page-part {
    margin-top: 40px;
}
.changeName span {
  display: inline-block;
  height: 1rem;
  font-size: 0.55rem !important;
  line-height: 1.6rem;
  margin-left:2rem;
}
.changeName span:nth-child(2) {
  margin-left:3rem;
  font-size: 0.36rem;
}
.changeName span:nth-child(3) {
  margin-left:1.9rem;
}
</style>


// WEBPACK FOOTER //
// src/components/change/gender.vue